module.exports = __webpack_public_path__ + "static/footer-joinus-bg-70316aebfdaa14987c8760b6eff9a0a9.jpg";